import clsx from 'clsx'
import { MouseEventHandler, ReactNode } from 'react'
import { TSizeAll } from 'src/types'
import styles from './ToggleButton.module.scss'

export const ToggleButton = ({
  id,
  wrapperId,
  isSelected,
  size,
  onClick,
  children,
}: {
  id: string
  wrapperId: string
  isSelected: boolean
  size: TSizeAll
  onClick: MouseEventHandler<HTMLButtonElement>
  children: ReactNode
}) => (
  <button
    className={clsx(styles.toggleButton, styles[size], {
      [styles.selected]: isSelected,
    })}
    onClick={onClick}
    role="tab"
    aria-selected={isSelected}
    aria-controls={`${wrapperId}-${id}`}
    tabIndex={isSelected ? 0 : -1}
  >
    <span className={styles.buttonInner}>{children}</span>
  </button>
)
